export default "__VITE_ASSET__ZVRX$bWX__"